export default __webpack_public_path__ + "static/media/factory__2.646a201c.jpg";